import { getApi, postApi, patchApi, deleteApi } from "./apiService";

// Function to create a banner
export const createBanner = (data) => {
    return postApi("/mp/banner/create", data); // POST request to create a banner
};

// Function to update a banner
export const updateBanner = (data) => {
    return patchApi("/mp/banner/update", data); // PATCH request to update a banner
};

// Function to get a banner by ID
export const getBanner = (id) => {
    return getApi(`/mp/banner/get/${id}`); // GET request to fetch a banner by ID
};

// Function to delete a banner
export const deleteBanner = (id) => {
    return deleteApi(`/mp/banner/delete/${id}`); // DELETE request to delete a banner
};
export const deactivateBanner = (id) => {
    return patchApi(`/mp/banner/deactivate`, { _id: id }); // DELETE request to delete a banner
};

export const getBannersByFilter = (params) => {
    // Convert params object to query string
    const queryString = new URLSearchParams(params).toString();

    return getApi(`/mp/banner/get-by-filter?${queryString}`); // GET request to fetch banners by filter
};
